var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "MyModal",
    {
      staticClass: "fengji-modal",
      attrs: { height: "auto", width: "420px", title: _vm.title || "风机" },
      on: {
        closeClick: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [_c("tower-info", { attrs: { turbine: _vm.turbine, scene: _vm.scene } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }